export const SAVE_PI_TAGS_EDITOR = 'SAVE_PI_TAGS_EDITOR';
export type SAVE_PI_TAGS_EDITOR = typeof SAVE_PI_TAGS_EDITOR;

export interface SavePITagsEditor {
    type: SAVE_PI_TAGS_EDITOR;
    id: string;
}

export function savePITagsEditor(id: string): SavePITagsEditor {
    return {
        type: SAVE_PI_TAGS_EDITOR,
        id
    };
}

export const CLOSE_PI_TAGS_EDITOR = 'CLOSE_PI_TAGS_EDITOR';
export type CLOSE_PI_TAGS_EDITOR = typeof CLOSE_PI_TAGS_EDITOR;

export interface ClosePITagsEditor {
    type: CLOSE_PI_TAGS_EDITOR;
    id: string;
}

export function closePITagsEditor(id: string): ClosePITagsEditor {
    return {
        type: CLOSE_PI_TAGS_EDITOR,
        id
    };
}

export const OPEN_PI_TAGS_EDITOR = 'OPEN_PI_TAGS_EDITOR';
export type OPEN_PI_TAGS_EDITOR = typeof OPEN_PI_TAGS_EDITOR;

export interface OpenPITagsEditor {
    type: OPEN_PI_TAGS_EDITOR;
    id: string;
    pageTags?: string;
    targetTags?: string;
}

export function openPITagsEditor(id: string, pageTags?: string, targetTags?: string): OpenPITagsEditor {
    return {
        type: OPEN_PI_TAGS_EDITOR,
        id,
        pageTags,
        targetTags
    };
}

export const PAGE_GROUP_TAGS_CHANGE = 'PAGE_GROUP_TAGS_CHANGE';
export type PAGE_GROUP_TAGS_CHANGE = typeof PAGE_GROUP_TAGS_CHANGE;

export interface PageGroupTagsChange {
    type: PAGE_GROUP_TAGS_CHANGE;
    id: string;
    value: string;
}

export function pageGroupTagsChange(id: string, value: string): PageGroupTagsChange {
    return {
        type: PAGE_GROUP_TAGS_CHANGE,
        id,
        value
    };
}

export const TARGET_TAGS_CHANGE = 'TARGET_TAGS_CHANGE';
export type TARGET_TAGS_CHANGE = typeof TARGET_TAGS_CHANGE;

export interface TargetTagsChange {
    type: TARGET_TAGS_CHANGE;
    id: string;
    value: string;
}

export function targetTagsChange(id: string, value: string): TargetTagsChange {
    return {
        type: TARGET_TAGS_CHANGE,
        id,
        value
    };
}

export type PiTagsEditorAction =
    | SavePITagsEditor
    | ClosePITagsEditor
    | OpenPITagsEditor
    | PageGroupTagsChange
    | TargetTagsChange;
